<div class="jit-assignment-footer">
  <span class="jit-assignment-footer__cancel" (click)="onCancel()">
    Cancel
  </span>
  <span class="jit-assignment-footer__apply" (click)="onApply()">
    Save changes
  </span>
</div>
